import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../features/authSlice';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import useSiteBootstrap from '../hooks/useSiteBootstrap';
import api from '../lib/api';
import { useToast } from '../components/common/ToastProvider';
import '../styles/ai-theme.css';

function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);
  const [form, setForm] = useState({ username: '', password: '' });
  const site = useSiteBootstrap();
  const { showToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(login(form));
    if (result.meta.requestStatus === 'fulfilled') {
      showToast('Login successful.', 'success');
      const u = result.payload?.user || {};
      if (u.is_staff || u.is_superuser) navigate('/admin');
      else navigate('/dashboard');
    }
  };

  const handleGoogleLogin = () => {
    const idToken = window.prompt('Paste Google ID token to continue');
    if (!idToken) return;
    api.post('/accounts/google-login/', { id_token: idToken }, { headers: { 'X-Bypass-Auth': '1' } })
      .then(({ data }) => {
        localStorage.setItem('access', data.access);
        localStorage.setItem('refresh', data.refresh);
        window.location.href = data.user?.is_staff || data.user?.is_superuser ? '/admin' : '/dashboard';
      })
      .catch((e) => {
        showToast(e?.response?.data?.error || 'Google login failed', 'danger');
      });
  };

  return (
    <div className="ai-scope">
      <div className="ai-bg">
        <div className="center-screen">
          <Container className="card-fixed">
            <Card className="glass-card p-3">
              <div className="glass-header d-flex align-items-center justify-content-between">
                <h4 className="h-title m-0">Login</h4>
                <span className="badge-soft">Secure Access</span>
              </div>
              <div className="p-3">
                <p className="h-subtle mb-3">Sign in to manage your AI workspace.</p>
                {error && <Alert variant="danger" className="py-2">{error}</Alert>}
                <Form onSubmit={handleSubmit} className="d-grid gap-3">
                  <Form.Group>
                    <Form.Label className="h-subtle">Username or Email</Form.Label>
                    <Form.Control className="input-ai" type="text" required value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} placeholder="Enter username or email" />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="h-subtle">Password</Form.Label>
                    <Form.Control className="input-ai" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Enter password" />
                  </Form.Group>
                  <Button type="submit" className="btn-ai w-100" disabled={loading}>{loading ? 'Logging in…' : 'Login'}</Button>
                  {site?.settings?.google_enabled && (
                    <Button type="button" variant="outline-light" className="w-100" onClick={handleGoogleLogin}>Continue with Google</Button>
                  )}
                  <Button type="button" className="btn-ai-ghost w-100" onClick={() => navigate('/')}>Back to site</Button>
                  <Button type="button" className="btn-auth-link w-100" onClick={() => navigate('/signup')}>Create new account</Button>
                  <Button type="button" className="btn-auth-link w-100" onClick={() => navigate('/reset-password')}>Forgot password?</Button>
                </Form>
              </div>
            </Card>
          </Container>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
